export const CODE_EDITOR_HEIGHT = {
  min: 'min',
  max: 'max',
};
